import React, { useState } from 'react';

const ALMA_URL = "https://secure.helloalma.com/providers/adrian-mirabile/#Expertise";
const HW_URL = "https://care.headway.co/providers/adrian-mirabile?utm_source=pem&utm_medium=direct_link&utm_campaign=194905";

const plans = [
  { name: "Aetna", via: "both" },
  { name: "Cigna", via: "both" },
  { name: "Allied Benefit Systems \u2013 Aetna", via: "alma" },
  { name: "Christian Brothers Services \u2013 Aetna", via: "alma" },
  { name: "Confide Enhanced EAP", via: "alma" },
  { name: "Health Scope \u2013 Aetna", via: "alma" },
  { name: "Meritain", via: "alma" },
  { name: "Nippon", via: "alma" },
  { name: "Resources for Living EAP", via: "alma" },
  { name: "Trustmark Health Benefits \u2013 Cigna", via: "alma" },
  { name: "Trustmark Small Business \u2013 Aetna", via: "alma" },
  { name: "Ascension", via: "headway" },
  { name: "Carelon Behavioral Health", via: "headway" },
  { name: "Quest Behavioral Health", via: "headway" },
  { name: "Kaiser Permanente \u2013 Mid Atlantic (VA)", via: "headway" },
];

const InsuranceWidget = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);

  const closeModal = () => setSelectedPlan(null);

  return (
    <>
      <div className="itc-ins" data-testid="insurance-widget">
        <p className="itc-sublabel">Select your insurance plan below to find out how to book.</p>
        <div className="itc-grid">
          {plans.map((plan) => (
            <button
              key={plan.name}
              className="itc-pill"
              onClick={() => setSelectedPlan(plan)}
              data-testid={`insurance-pill-${plan.name.toLowerCase().replace(/\s+/g, '-')}`}
            >
              {plan.name}
            </button>
          ))}
        </div>
        <p className="itc-note">
          Don't see your plan? Self-pay options are also available —{' '}
          <a href="#contact">reach out for details.</a>
        </p>
      </div>

      {selectedPlan && (
        <div
          className="itc-overlay open"
          role="dialog"
          aria-modal="true"
          onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}
          data-testid="insurance-modal-overlay"
        >
          <div className="itc-modal" data-testid="insurance-modal">
            <button className="m-close" aria-label="Close" onClick={closeModal}>&times;</button>
            <p className="m-label">Coverage confirmed</p>
            <p className="m-plan">{selectedPlan.name}</p>

            {selectedPlan.via === "both" && (
              <>
                <p className="m-body">Great news — your plan is accepted through both our networks. Either link below will get you started.</p>
                <div className="m-btns">
                  <a href={ALMA_URL} target="_blank" rel="noopener noreferrer" className="m-btn m-btn-alma">Book via Alma</a>
                  <a href={HW_URL} target="_blank" rel="noopener noreferrer" className="m-btn m-btn-outline">Book via Headway</a>
                </div>
              </>
            )}

            {selectedPlan.via === "alma" && (
              <>
                <p className="m-body">Your plan is accepted through Alma. Click below to verify your coverage and book a session.</p>
                <div className="m-btns">
                  <a href={ALMA_URL} target="_blank" rel="noopener noreferrer" className="m-btn m-btn-alma">Verify &amp; Book via Alma</a>
                </div>
              </>
            )}

            {selectedPlan.via === "headway" && (
              <>
                <p className="m-body">Your plan is accepted through Headway. Click below to verify your coverage and book a session.</p>
                <div className="m-btns">
                  <a href={HW_URL} target="_blank" rel="noopener noreferrer" className="m-btn m-btn-hw">Verify &amp; Book via Headway</a>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default InsuranceWidget;
